import type { IconData } from '@stacksjs/iconify-core'

export const ruler: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m14.95 7.879l-.707-.707a1 1 0 0 1 1.414-1.415l.707.707l1.414-1.414l-2.828-2.828L2.222 14.95l2.828 2.828l1.414-1.414L5.05 14.95a1 1 0 0 1 1.414-1.414L7.88 14.95l1.414-1.414l-.707-.708A1 1 0 0 1 10 11.414l.707.707l1.414-1.414l-1.414-1.414a1 1 0 0 1 1.414-1.414l1.415 1.414zM.808 13.536L13.536.808a2 2 0 0 1 2.828 0l2.828 2.828a2 2 0 0 1 0 2.828L6.464 19.192a2 2 0 0 1-2.828 0L.808 16.364a2 2 0 0 1 0-2.828\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default ruler
